import React from "react"
import { Col, Input, Label, Row } from "reactstrap"
import DynamicFormViewOnly from "components/custom/DynamicForm/View/ViewOnly/DynamicFormViewOnly"

const OccApproachSectionViewOnly = ({
  alternative,
  scenario,
  sectionFormId,
  systemRetirementsLabel,
}) => {
  if (scenario?.approachTabFormID > 0) {
    return (
      <Row>
        <Col md="12">
          <DynamicFormViewOnly
            formId={scenario.approachTabFormID}
            itemId={alternative?.alternativeID}
            scenarioId={alternative?.scenarioID}
          />
        </Col>
      </Row>
    )
  } else
    return (
      <React.Fragment>
        <Row>
          <Col sm="12">
            <div style={{ float: "right" }}>
              {/* <HelpIconWithModal itemId={2} /> */}
            </div>
            <div className="mb-3">
              <Label className="form-label">Proposed Solution</Label>
              <p>{alternative.proposedSolution}</p>
            </div>
            <div className="mb-3">
              <Label className="form-label">Alternative Analysis Summary</Label>
              <p>{alternative.analysisSummary}</p>
            </div>
            <div className="mb-3">
              <Label className="form-label">Deliverables</Label>
              <p>{alternative.deliverables}</p>
            </div>
            <div className="mb-3">
              <Label className="form-label">Dependencies</Label>
              <p>{alternative.dependencies}</p>
            </div>
            <div className="mb-3">
              <Label className="form-label">Delivery Risk</Label>
              <p>{alternative.deliveryRisk}</p>
            </div>
            <div className="mb-3">
              <div className="d-flex-row ai-center">
                <Label className="form-label">{systemRetirementsLabel}</Label>
                <div className="form-check" style={{ marginLeft: "20px" }}>
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    id="ff-hasSystemRetirements"
                    checked={alternative.hasSystemRetirements}
                    disabled={true}
                  />
                  <Label
                    className="form-check-label"
                    for="ff-hasSystemRetirements"
                  >
                    Check if applicable
                  </Label>
                </div>
              </div>
              <p>{alternative.systemRetirements}</p>
            </div>
            <div className="mb-3">
              <Label className="form-label">Assumptions</Label>
              <p>{alternative.assumptions}</p>
            </div>
          </Col>
        </Row>
        {sectionFormId != 0 && (
          <>
            <Row>
              <Col md="12">
                <div className="divider"></div>
                <DynamicFormViewOnly
                  formId={sectionFormId}
                  itemId={alternative?.alternativeID}
                  scenarioId={alternative?.scenarioID}
                />
              </Col>
            </Row>
          </>
        )}
      </React.Fragment>
    )
}

export default OccApproachSectionViewOnly
